(() => {
  const rail = document.querySelector('.ms-floating-actions');
  if (!rail) return;
  const backTop = rail.querySelector('[data-ms-back-top]');
  if (backTop) {
    const updateBackTop = () => { backTop.hidden = window.scrollY < 400; };
    window.addEventListener('scroll', updateBackTop, { passive: true });
    backTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
    updateBackTop();
  }
  const toggle = rail.querySelector('.contact-rail-toggle');
  const close = () => { rail.classList.remove('is-expanded'); toggle.setAttribute('aria-expanded', 'false'); };
  toggle.addEventListener('click', () => toggle.setAttribute('aria-expanded', String(rail.classList.toggle('is-expanded'))));
  document.addEventListener('click', event => {
    if (!rail.contains(event.target) && !event.target.closest('.ms-inquiry-dialog') && !document.querySelector('.ms-inquiry-dialog[open]')) close();
  });
  rail.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); toggle.focus(); } });
  // The inline enquiry already supplies the contact action. Keep its copy and
  // fields unobstructed on mobile, including when the on-screen keyboard opens.
  const mobile = window.matchMedia('(max-width: 749px)');
  const visibleEnquiries = new Set();
  const observedEnquiries = new Set();
  const updateEnquiryVisibility = () => {
    const active = document.activeElement;
    const keyboardFocus = rail.contains(active) && active.matches(':focus-visible');
    const hidden = mobile.matches && visibleEnquiries.size > 0 && !keyboardFocus;
    if (hidden) {
      close();
      if (rail.contains(active)) active.blur();
    }
    rail.classList.toggle('is-inquiry-visible', hidden);
  };
  const enquiryObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target.isConnected) visibleEnquiries.add(entry.target);
      else visibleEnquiries.delete(entry.target);
    }
    updateEnquiryVisibility();
  });
  const observeEnquiries = () => {
    enquiryObserver.disconnect();
    visibleEnquiries.clear();
    observedEnquiries.clear();
    document.querySelectorAll('main .compact-enquiry__intro, main [data-ms-unified-inquiry]').forEach(node => {
      if (!node.closest('dialog')) observedEnquiries.add(node.closest('.ms-oem-reference') || node);
    });
    observedEnquiries.forEach(region => enquiryObserver.observe(region));
    updateEnquiryVisibility();
  };
  mobile.addEventListener('change', updateEnquiryVisibility);
  rail.addEventListener('focusout', () => requestAnimationFrame(updateEnquiryVisibility));
  observeEnquiries();
  document.addEventListener('shopify:section:load', observeEnquiries);
  document.addEventListener('shopify:section:unload', event => {
    for (const region of observedEnquiries) {
      if (event.target === region || event.target.contains(region)) {
        enquiryObserver.unobserve(region);
        observedEnquiries.delete(region);
        visibleEnquiries.delete(region);
      }
    }
    updateEnquiryVisibility();
  });
  let observedFooter;
  const observeFooter = () => {
    observer.disconnect();
    rail.classList.remove('is-footer-visible');
    observedFooter = document.querySelector('[data-mas-footer]');
    if (observedFooter) observer.observe(observedFooter);
  };
  const observer = new IntersectionObserver(([entry]) => {
    if (!entry || entry.target !== observedFooter || !entry.target.isConnected) return;
    const hidden = entry.isIntersecting && entry.intersectionRatio >= .15;
    rail.classList.toggle('is-footer-visible', hidden && !rail.contains(document.activeElement));
    if (hidden) close();
  }, { threshold: [0, .15] });
  observeFooter();
  document.addEventListener('shopify:section:load', observeFooter);
  document.addEventListener('shopify:section:unload', event => {
    if (observedFooter && (event.target === observedFooter || event.target.contains?.(observedFooter))) {
      observer.disconnect();
      observedFooter = null;
      rail.classList.remove('is-footer-visible');
    }
  });
})();
